import Configurations from '@/views/Configurations/Index'

import ConfigurationsMaterials from '@/views/Configurations/Materials/Index'
import ConfigurationsMaterialsPapers from '@/views/Configurations/Materials/Papers/Index'
import ConfigurationsMaterialsPaperGroups from '@/views/Configurations/Materials/PaperGroups/Index'
import ConfigurationsMaterialsOtherMaterials from '@/views/Configurations/Materials/OtherMaterials/Index'

import ConfigurationsProductProductionProcesses from '@/views/Configurations/ProductProductionProcesses/Index'

import ConfigurationsMachines from '@/views/Configurations/Machines/Index'

import ConfigurationsProductionSites from '@/views/Configurations/ProductionSites/Index'

import ConfigurationsProducts from '@/views/Configurations/Products/Index'
import ConfigurationsProductsProduct from '@/views/Configurations/Products/Product/Index'

import ConfigurationsRubberRegistry from '@/views/Configurations/RubberRegistry/Index'

import ConfigurationsTools from '@/views/Configurations/Tools/Index'
import ConfigurationsToolsDieCutters from '@/views/Configurations/Tools/DieCutters/Index'
import ConfigurationsToolsDieCuttersDieCutter from '@/views/Configurations/Tools/DieCutters/DieCutter'

import ConfigurationsCalculationsCosts from '@/views/Configurations/CalculationsCosts/Index'
import ConfigurationsCalculationsCostsNettoMarkUp from '@/views/Configurations/CalculationsCosts/NettoMarkUp/Index'
import ConfigurationsCalculationsCostsProductGroupFactors from '@/views/Configurations/CalculationsCosts/ProductGroupFactors/Index'
import ConfigurationsCalculationsCostsTradersMarkUp from '@/views/Configurations/CalculationsCosts/TradersMarkUp/Index'

export default [
    {
        path: '/configurations',
        name: 'configurations',
        component: Configurations,
        meta: {
            title: 'Konfiguracje',
            menuRendered: true,
            menuTitle: 'Konfiguracje',
            icon: 'mdi-cog'
        },
        children: [
            {
                path: '/configurations/materials',
                name: 'configurationsMaterials',
                component: ConfigurationsMaterials,
                meta: {
                    title: 'Konfiguracje / Materiały',
                    menuRendered: true,
                    menuTitle: 'Materiały',
                    requiresAuth: true,
                    permission: 'dictionaries',
                },
                redirect: { name: 'configurationsMaterialsPapers' },
                children: [
                    {
                        path: '/configurations/materials/papers',
                        name: 'configurationsMaterialsPapers',
                        component: ConfigurationsMaterialsPapers,
                        meta: {
                            title: 'Konfiguracje / Papiery',
                            requiresAuth: true,
                            permission: 'dictionaries',
                        }
                    },
                    {
                        path: '/configurations/materials/paper-groups',
                        name: 'configurationsMaterialsPaperGroups',
                        component: ConfigurationsMaterialsPaperGroups,
                        meta: {
                            title: 'Konfiguracje / Grupy papierów',
                            requiresAuth: true,
                            permission: 'dictionaries',
                        }
                    },
                    {
                        path: '/configurations/materials/other-materials',
                        name: 'configurationsMaterialsOtherMaterials',
                        component: ConfigurationsMaterialsOtherMaterials,
                        meta: {
                            title: 'Konfiguracje / Inne materiały',
                            requiresAuth: true,
                            permission: 'dictionaries',
                        }
                    },
                ]
            },
            {
                path: '/configurations/production-processes',
                name: 'configurationsProductProductionProcesses',
                component: ConfigurationsProductProductionProcesses,
                meta: {
                    title: 'Konfiguracje / Procesy produkcyjne',
                    menuRendered: true,
                    menuTitle: 'Procesy produkcyjne',
                    requiresAuth: true,
                    permission: 'production_processes',
                }
            },
            {
                path: '/configurations/machines',
                name: 'configurationsMachines',
                component: ConfigurationsMachines,
                meta: {
                    title: 'Konfiguracje / Maszyny',
                    menuRendered: true,
                    menuTitle: 'Maszyny',
                    requiresAuth: true,
                    permission: 'machines',
                }
            },
            {
                path: '/configurations/production-sites',
                name: 'configurationsProductionSites',
                component: ConfigurationsProductionSites,
                meta: {
                    title: 'Konfiguracje / Stanowiska raportowania',
                    menuRendered: true,
                    menuTitle: 'Stanowiska raportowania',
                    requiresAuth: true,
                    permission: 'production_sites',
                }
            },
            {
                path: '/configurations/products',
                name: 'configurationsProducts',
                component: ConfigurationsProducts,
                meta: {
                    title: 'Konfiguracje / Produkty',
                    menuRendered: true,
                    menuTitle: 'Produkty',
                    requiresAuth: true,
                    permission: 'products',
                }
            },
            {
                path: '/configurations/products/:id',
                name: 'configurationsProductsProduct',
                component: ConfigurationsProductsProduct,
                meta: {
                    title: 'Konfiguracje / Produkty / Produkt',
                    requiresAuth: true,
                    permission: 'products',
                }
            },
            {
                path: '/configurations/tools',
                name: 'configurationsTools',
                component: ConfigurationsTools,
                meta: {
                    title: 'Konfiguracje / Narzędzia',
                    menuRendered: true,
                    menuTitle: 'Narzędzia',
                    requiresAuth: true,
                    permission: 'die_cutters',
                },
                redirect: { name: 'configurationsToolsDieCutters' },
                children: [
                    {
                        path: '/configurations/tools/die-cutters',
                        name: 'configurationsToolsDieCutters',
                        component: ConfigurationsToolsDieCutters,
                        meta: {
                            title: 'Konfiguracje / Narzędzia / Lista wykrojników',
                            requiresAuth: true,
                            permission: 'die_cutters_read',
                        }
                    },
                    {
                        path: '/configurations/tools/die-cutter/create',
                        name: 'ConfigurationsToolsDieCuttersDieCutterCreate',
                        component: ConfigurationsToolsDieCuttersDieCutter,
                        meta: {
                            title: 'Konfiguracje / Narzędzia / Wykrojniki / Tworzenie wykrojnika',
                            requiresAuth: true,
                            permission: 'die_cutters_admin_create',
                        }
                    },
                    {
                        path: '/configurations/tools/die-cutter/:id',
                        name: 'ConfigurationsToolsDieCuttersDieCutter',
                        component: ConfigurationsToolsDieCuttersDieCutter,
                        meta: {
                            title: 'Konfiguracje / Narzędzia / Wykrojniki / Wykrojnik',
                            requiresAuth: true,
                            permission: 'die_cutters_read',
                        }
                    },
                ]
            },
            {
                path: '/configurations/rubber-registry',
                name: 'configurationsRubberRegistry',
                component: ConfigurationsRubberRegistry,
                meta: {
                    title: 'Konfiguracje / Rejestr gum',
                    menuRendered: true,
                    menuTitle: 'Rejestr gum',
                    requiresAuth: true,
                    permission: 'rubbers',
                }
            },
            {
                path: '/configurations/calculations-costs',
                name: 'configurationsCalculationsCosts',
                component: ConfigurationsCalculationsCosts,
                meta: {
                    title: 'Konfiguracje / Składniki kalkulacji',
                    menuRendered: true,
                    menuTitle: 'Składniki kalkulacji',
                    requiresAuth: true,
                    permission: 'finances',
                },
                redirect: { name: 'configurationsCalculationsCostsNettoMarkUp' },
                children: [
                    {
                        path: '/configurations/calculations-costs/netto-mark-up',
                        name: 'configurationsCalculationsCostsNettoMarkUp',
                        component: ConfigurationsCalculationsCostsNettoMarkUp,
                        meta: {
                            title: 'Konfiguracje / Składniki kalkulacji / Narzut netto',
                            requiresAuth: true,
                            permission: 'finances_read',
                        }
                    },
                    {
                        path: '/configurations/calculations-costs/product-group-factors',
                        name: 'configurationsCalculationsCostsProductGroupFactors',
                        component: ConfigurationsCalculationsCostsProductGroupFactors,
                        meta: {
                            title: 'Konfiguracje / Składniki kalkulacji / Współczynnik grupy produktowej',
                            requiresAuth: true,
                            permission: 'finances_read',
                        }
                    },
                    {
                        path: '/configurations/calculations-costs/traders-mark-up',
                        name: 'configurationsCalculationsCostsTradersMarkUp',
                        component: ConfigurationsCalculationsCostsTradersMarkUp,
                        meta: {
                            title: 'Konfiguracje / Składniki kalkulacji / Narzut handlowca',
                            requiresAuth: true,
                            permission: 'finances_read',
                        }
                    }
                ]
            },
        ]
    },
]